import LocalizedLink from '@components/Localization/LocalizedLink'
import { Container, Icon } from '@components/gassan-ui'
import { Text } from '@components/rolex-ui/Text'
import { FC } from 'react'

type RolexBreadcrumbsProps = {
  items: { label: string; href: string }[]
  currentPageTitle: string
}

export const RolexBreadcrumbs: FC<RolexBreadcrumbsProps> = ({ items, currentPageTitle }) => {
  return (
    <div className="bg-gradient-to-r from-rolexGreenDark to-rolexPrimary">
      <Container className="flex h-8 items-center gap-1">
        <LocalizedLink href="/rolex">
          <a>
            <Text
              variant="fixed14"
              weight="light"
              className="text-white transition-colors duration-150 hover:text-rolexOceanGreen"
            >
              Rolex
            </Text>
          </a>
        </LocalizedLink>
        <Icon color="white" icon="chevron-right" size={16} />
        {items.map((item, index) => (
          <div key={index} className="color-white flex items-center gap-1">
            <LocalizedLink href={item.href}>
              <a>
                <Text
                  variant="fixed14"
                  weight="light"
                  className="text-white transition-colors duration-150 hover:text-rolexOceanGreen"
                >
                  {item.label}
                </Text>
              </a>
            </LocalizedLink>
            <Icon color="white" icon="chevron-right" size={16} />
          </div>
        ))}
        <Text variant="fixed14" weight="light" className="text-rolexOceanGreen">
          {currentPageTitle}
        </Text>
      </Container>
    </div>
  )
}
